"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DefaultPopoverButton;

var _react = _interopRequireDefault(require("react"));

var _reactSvg = require("react-svg");

var _settings = _interopRequireDefault(require("../../settings"));

var _CircleButton = _interopRequireDefault(require("../CircleButton/CircleButton"));

function DefaultPopoverButton(props) {
  var showPopover = props.showPopover,
      setShowPopover = props.setShowPopover;
  return /*#__PURE__*/_react["default"].createElement(_CircleButton["default"], {
    onClick: function onClick() {
      return setShowPopover(!showPopover);
    },
    isOpen: showPopover
  }, /*#__PURE__*/_react["default"].createElement(_reactSvg.ReactSVG, {
    src: _settings["default"].icons.threeDots,
    style: {
      height: "20px",
      width: "20px"
    }
  }));
}